import React from 'react';

import styled from 'styled-components';

// import StyleVariables from '@components/Gui/StyleVariables.js';

const StyledSpan = styled.span`
    padding: 0 0.5em;
    vertical-align: baseline;
    font-size: 1.5em;
    line-height: 0.5em;
`;

const NwBullet = (props) => {
    return <StyledSpan>&bull;</StyledSpan>;
};

export default NwBullet;
